export default __webpack_public_path__ + "static/media/add_building_hero.643501b5.png";